export const MAIN_STATES = [];
